/**
 * A canonical tool id as its product name.
 *
 * The registry supplies a display label wherever a detection carries one, and
 * several routes carry only the id. Those places rendered the slug raw, so one
 * screen said "Microsoft Outlook" and another said "microsoft_outlook" for the
 * same tool.
 *
 * This lived privately inside the analysis run page, which is why the company
 * page did not have it.
 */

/** Registry words that are acronyms rather than names, so sap_hana does not
 *  read as "Sap Hana" on a screen an operator scans for a brand. */
const ACRONYMS = new Set(['sap', 'aws', 'ibm', 'sql', 'hr', 'crm', 'erp', 'api']);

export function toolLabel(id: string): string {
  return id
    .split('_')
    .map((w) => (ACRONYMS.has(w) ? w.toUpperCase() : (w[0]?.toUpperCase() ?? '') + w.slice(1)))
    .join(' ');
}
